// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var ViewStack = require("../../../reason/common/ViewStack.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Radio = require("../../../uikit/reason/atoms/Form/Form__Radio.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var CssGrid = require("components/CssGrid");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardRelayKeyFactsDraftType_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsDraftType_draft_graphql.bs.js");

var convertFragment = PropertyWizardRelayKeyFactsDraftType_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsDraftType_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsDraftType_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsDraftType_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsDraftType_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayKeyFactsDraftType_draft_graphql.Utils.localDraftPropertyType_decode;

var DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayKeyFactsDraftType_draft_graphql.Utils.localDraftPropertyType_fromString;

var DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__KeyFacts__DraftType(props) {
  var draft = use(props.draft);
  var update = PropertyWizardFormRelay.useUpdateDraftProperty();
  var propertyType = draft.draftProperty.propertyType;
  return JsxRuntime.jsx(FormV5.FormSection.make, {
              children: JsxRuntime.jsx(CssGrid.Grid, {
                    children: Caml_option.some(JsxRuntime.jsx(CssGrid.Cell, {
                              width: 12,
                              children: Caml_option.some(JsxRuntime.jsx(ViewStack.make, {
                                        flexDirection: "column",
                                        children: Caml_option.some(JsxRuntime.jsx(Form__Radio.RadioList.make, {
                                                  selected: propertyType,
                                                  items: [
                                                    {
                                                      label: "For Sale",
                                                      value: "FOR_SALE"
                                                    },
                                                    {
                                                      label: "Rental",
                                                      value: "RENTAL"
                                                    }
                                                  ],
                                                  name: "listingType",
                                                  toValue: (function (v) {
                                                      return v;
                                                    }),
                                                  onChange: (function (v) {
                                                      update(function (c) {
                                                            var newrecord = Caml_obj.obj_dup(c);
                                                            newrecord.propertyType = v;
                                                            return newrecord;
                                                          });
                                                    })
                                                }))
                                      }))
                            }))
                  })
            });
}

var Components;

var FormSection;

var Grid;

var Cell;

var make = PropertyWizardRelay__KeyFacts__DraftType;

exports.Components = Components;
exports.FormSection = FormSection;
exports.Grid = Grid;
exports.Cell = Cell;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* FormV5 Not a pure module */
